import { Component, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { DanoneMslProduct } from 'src/app/assabil-sales/models/entities/danone-msl_product';
import { MslPipe } from 'src/app/assabil-sales/pipes/msl-pipe';
import { GeoArea } from 'src/app/assabil-kernel/models/entities/control-tables/geo-area-entity';
import { ProductLovComponent } from 'src/app/assabil-admin/components/master-data/product/product-lov/product-lov.component';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { LeanDataFormComponent } from 'src/app/tools/components/lean-data-form/lean-data-form.component';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { SalesAdminDanoneService } from 'src/app/assabil-sales/services/sales-admin-danone-service';
import { LeanConfirmationComponent } from 'src/app/tools/components/lean-confirmation/lean-confirmation.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'danone_msl_product-list',
  templateUrl: './danone_msl_product-list.component.html',
  styleUrls: ['./danone_msl_product-list.component.scss']
})


export class DanoneMslProductListComponent extends BasePage2<DanoneMslProduct> {
  
  @ViewChild('leanDataForm', {static : false}) leanDataForm : LeanDataFormComponent;
  
  danoneMslProducts  : DanoneMslProduct[] = [];
  editMode            : boolean = false;
  mslPipe             : MslPipe = new MslPipe();
  geoArea             : GeoArea;
  selectedGeoArea     : GeoArea = null


  visible1  : boolean = true;
  visible2  : boolean = true;
  visible3  : boolean = true;
  editable1 : boolean = false;
  editable2 : boolean = false;
  editable3 : boolean = false;

  productMarketColumn     = {prop : "product.productAnalysisGroup4.name", name:"Marché",        readOnly : true, hidden : false};
  productBrandCodeColumn  = {prop : "product.brand.brandCode",            name:"Code Gamme",    readOnly : true, hidden : false};
  productBrandNameColumn  = {prop : "product.brand.name",                 name:"Nom Gamme",     readOnly : true, hidden : false};
  productCodeColumn       = {prop : "product.productCode",                name:"Code Produit",  readOnly : true, hidden : false};
  productNameColumn       = {prop : "product.longDescription",            name:"Nom Produit",   readOnly : true, hidden : false};
  rank1Column             = {prop : "rank1",                              name:"Centre",        readOnly : !this.editable1, hidden : false, pipe : this.mslPipe};
  rank2Column             = {prop : "rank2",                              name:"Périphérique",  readOnly : !this.editable2, hidden : false, pipe : this.mslPipe};
  rank3Column             = {prop : "rank3",                              name:"Extérieur",     readOnly : !this.editable3, hidden : false, pipe : this.mslPipe};


  constructor(
    protected danoneService     : SalesAdminDanoneService,
    protected masterDataService : MasterDataService,
    protected controlTablesService : ControlTablesService,
    protected toastr            : ToastrService,
    protected router            : Router,
    protected baseService       : BaseService,
    protected leanUtilsService  : LeanUtilsService, 
    protected dialog            : MatDialog,
    protected location          : Location) {
   
       super(toastr, router, baseService, leanUtilsService, location);

       this.entityName = 'danoneMslProduct';

       this.listFields = [
        this.productMarketColumn,   
        this.productBrandCodeColumn,
        this.productBrandNameColumn,
        this.productCodeColumn,
        this.productNameColumn,
        this.rank1Column,      
        this.rank2Column,      
        this.rank3Column      
      ];

    }

//----------------------------------------------------------------------
ngOnInit(){
        super.ngOnInit();
        this.controlTablesService.personGeoAreaGet().then(result => {
          this.geoArea = result;
        })
    }
//----------------------------------------------------------------------

//----------------------------------------------------------------------
getRows(): DanoneMslProduct[] {
    return this.danoneMslProducts;
  }
//----------------------------------------------------------------------

  
//----------------------------------------------------------------------
  saveRow(row: DanoneMslProduct): Promise<DanoneMslProduct> {
    return null; 
  }
//----------------------------------------------------------------------



//----------------------------------------------------------------------
  loadData() {
    this.danoneService.danoneMslProductGet(this.selectedGeoArea.geoAreaCode).then(result => {
      this.danoneMslProducts = result;
      for (let tmp of this.danoneMslProducts) {
        tmp.edit = true;
      }
    })
  }
//----------------------------------------------------------------------



//----------------------------------------------------------------------
saveData(){
    this.danoneService.danoneMslProductSave(this.danoneMslProducts).then(result => {
      this.danoneMslProducts = result;
      this.leanUtilsService.success();
    })
  }
//----------------------------------------------------------------------
  


//----------------------------------------------------------------------
unselectAllGeoAreas(geoAreas){
    for(let el of geoAreas)
    {
      el.selected=false;
      if(el.subGeoAreas){
        this.unselectAllGeoAreas(el.subGeoAreas)
      }
    }
  }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
init(){
  if (! this.selectedGeoArea) {
    this.showError("Prière de sélectionner d'abord une région dans le filtre");
    return;
  }

  let confirmationMessage = "Confimez-vous bien l'initialisation des données de la région";

  let dialogRef = this.dialog.open(LeanConfirmationComponent, {autoFocus : false, hasBackdrop : false, data : {title : "Confirmation", confirmationMessage: confirmationMessage}});
  dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.danoneService.danoneMslProductInit(this.selectedGeoArea.geoAreaCode).then(result => {
          this.danoneMslProducts = result;
          for (let tmp of this.danoneMslProducts) {
            tmp.edit = true;
          }
        })
      }
  });
    
}
//----------------------------------------------------------------------




products : Product[];
//----------------------------------------------------------------------
new(){
  if (! this.selectedGeoArea) {
    this.showError("Priere de charger les données de la région d'abord");
    return;
  }

  let dialogRef = this.dialog.open(ProductLovComponent, {autoFocus: false,  hasBackdrop : false,  data : {dual : true, products : this.products}});
  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      this.products = result.products;
      if (result.selectedProducts) {
        this.addProducts(result.selectedProducts)
      }
    }
  });
}
//------------------------------------------------------------------------------------------------------


addProducts(products : Product[]){
  for (let product of products){
      let found : boolean = false;
      for (let p of this.danoneMslProducts) {
          if (p.product.productCode == product.productCode) {
            found = true;
            break;
          }
      }
      if (found) {
        continue;
      }
      let nr = new DanoneMslProduct();
      nr.inserted = true;
      nr.edit      = true;
      nr.geoAreaCode = this.selectedGeoArea.geoAreaCode; 
      nr.rank1 = 0;
      nr.rank2 = 0;
      nr.rank3 = 0;
      nr.product  = new Product();
      nr.product.productCode        = product.productCode;
      nr.product.longDescription    = product.longDescription;
      this.danoneMslProducts.push(nr);
  }
  this.danoneMslProducts = [...this.danoneMslProducts];  
}
//----------------------------------------------------------------------




  //----------------------------------------------------------------------
  selectGeoAreaAndGo(geoArea : GeoArea){ 
    this.selectGeoArea(geoArea);
    this.leanDataForm.hideFilter();
    this.loadData();
  }
  selectGeoArea(geoArea : GeoArea){
    if (this.selectedGeoArea != null) this.selectedGeoArea.selected = false;
    this.selectedGeoArea = geoArea;
    this.selectedGeoArea.selected=true;
  }
//----------------------------------------------------------------------

}